import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiEndpoints } from 'src/app/app-routes';
import { StoreService } from 'src/app/services/store/store.service';
import { HEADER_KEYS } from 'src/app/utils/constants';
import { environment } from 'src/environments/environment';

@Injectable()
export class HttpAuthenticatorInterceptor implements HttpInterceptor {
	constructor(private readonly storeService: StoreService) {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		const reqClone = request.clone({ setHeaders: this.buildHeaders(request) });
		return next.handle(reqClone);
	}

	private buildHeaders(request: HttpRequest<unknown>): Record<string, string> {
		const url = request.url;
		const journey = this.storeService.journeyMetadata;

		const isValidate = url.includes(ApiEndpoints.publicSimulatorExp.validate);
		const isInitialParameters = url.includes(ApiEndpoints.publicSimulatorExp.initialParameters);

		const baseHeaders: Record<string, string> = {
			...environment.header,
			[HEADER_KEYS.trackingId]: crypto.randomUUID(),
			[HEADER_KEYS.referenceOperation]: url.split('/').pop()!,
		};

		if (journey?.uuid && !isValidate) {
			baseHeaders[HEADER_KEYS.uuid] = journey.uuid;
		}

		if (journey?.productType && !isInitialParameters) {
			baseHeaders[HEADER_KEYS.referenceService] = journey.productType;
		}

		return baseHeaders;
	}
}
